import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import type { LeafAlert } from '@cigna/leaf-web/lib/wc';

import '@cigna/leaf-web/lib/wc/components/alert/alert';

@Component({
  selector: 'cigna-leaf-alert',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-alert
      [headerText]="headerText"
      [status]="status"
      [variant]="variant"
      [emphasis]="emphasis"
      [dismissed]="dismissed"
      [notDismissible]="notDismissible"
      ><ng-content></ng-content
    ></leaf-alert>
  `,
})
export class CignaLeafAlertComponent {
  @Input() headerText: LeafAlert['headerText'];
  @Input() status: LeafAlert['status'] = 'info';
  @Input() variant: LeafAlert['variant'] = 'standalone';
  @Input() emphasis: LeafAlert['emphasis'] = 'subtle';
  @Input() dismissed: LeafAlert['dismissed'];
  @Input() notDismissible: LeafAlert['notDismissible'];
}
